import axios from 'axios'
import { CMS_API_BASE } from './config'

const TOKEN_KEY = 'kanban_cms_token'
const USER_KEY = 'kanban_cms_user'

function token() {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch (e) {
    return ''
  }
}

const http = axios.create({ baseURL: CMS_API_BASE, timeout: 20000 })

http.interceptors.request.use(config => {
  const t = token()
  if (t) config.headers.Authorization = 'Bearer ' + t
  return config
})

http.interceptors.response.use(
  res => {
    const body = res.data
    // 统一错误语义：HTTP 200 但 success=false 也视为失败
    if (body && body.success === false) {
      const err = new Error(body.msg || '请求失败')
      err.code = body.code
      err.status = res.status
      if (err.code === 'UNAUTHORIZED') {
        setAuth(null, null)
        if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('cms-unauthorized'))
      }
      return Promise.reject(err)
    }
    return body
  },
  err => Promise.reject(err)
)

export function setAuth(tk, user) {
  try {
    if (tk) localStorage.setItem(TOKEN_KEY, tk)
    else localStorage.removeItem(TOKEN_KEY)
    if (user) localStorage.setItem(USER_KEY, JSON.stringify(user))
    else localStorage.removeItem(USER_KEY)
  } catch (e) { /* localStorage 不可用时退化成内存 token，仅本次会话有效 */ }
}

export function currentUser() {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export function isLogin() {
  return !!token()
}

export const api = {
  login(account, password) {
    return http.post('/auth/login', { account, password }).then(r => r.data)
  },
  verify() {
    return http.get('/auth/verify').then(r => r.data)
  },
  fetchAll() {
    return http.get('/content').then(r => r.data || {})
  },
  fetchScope(scope) {
    return http.get('/content/' + encodeURIComponent(scope)).then(r => r.data)
  },
  saveScope(scope, content) {
    return http.put('/content/' + encodeURIComponent(scope), { content }).then(r => r.data)
  },
  scopes() {
    return http.get('/content/_meta/scopes').then(r => r.data || [])
  },
  /** 把页面运行时扫描到的原文案补登记进该页目录（只新增不覆盖，无需登录） */
  postTexts(scope, texts) {
    return http.post('/content/' + encodeURIComponent(scope) + '/texts', { texts }).then(r => r.data || {})
  },
  history(scope) {
    return http.get('/content/_meta/history/' + encodeURIComponent(scope)).then(r => r.data || [])
  },
  rollback(scope, name) {
    return http.post('/content/_meta/rollback', { scope, name }).then(r => r.data)
  },
  mediaList(type) {
    return http.get('/media', { params: type ? { type } : {} }).then(r => r.data || [])
  },
  uploadMedia(file) {
    const fd = new FormData()
    fd.append('file', file)
    return http.post('/media', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data)
  },
  removeMedia(name) {
    return http.delete('/media/' + encodeURIComponent(name)).then(r => r.data)
  },
}

export default api
